<template>
  <div class="contact-info">
    <div class="contact-item">
      <span class="icon">📞</span>
      <span>{{ phoneInfo }}</span>
    </div>
    <div class="contact-item">
      <span class="icon">🕒</span>
      <span>{{ workTimeInfo }}</span>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from "vue";
import { useDefaultInfoStore } from "@/stores/defaultInfo";

const defaultInfoStore = useDefaultInfoStore();

// 使用计算属性安全获取数据，提供默认值
const phoneInfo = computed(() => {
  return defaultInfoStore.getFormateInfo!.head_phone![0] || "";
});

const workTimeInfo = computed(() => {
  // 尝试多个可能的 key，按优先级查找
  const info = defaultInfoStore.getFormateInfo!.head_info![0] || "";
  return info;
});
</script>

<style scoped>
.contact-info {
  display: flex;
  flex-direction: column;
  gap: 5px;
}

.contact-item {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 0.9rem;
  color: #555;
}

.contact-item .icon {
  font-size: 1rem;
}
</style>
